<template>
    <div>
        <!--      <mt-cell title="客戶問卷調查" style="text-align: center"></mt-cell>-->
        <!--      <mt-field label="客戶姓名：" placeholder="" v-model="customerName">(可以匿名)</mt-field>-->
        <!--      <mt-field label="投保日期：" type="date" placeholder="" v-model="insuranceDate"></mt-field>-->
        <div v-if="showMore">
            <div v-if="show">
                <el-card class="box-card2 box_car2">
                    <div slot="header" class="clearfix">
                        <p style="text-align: center;font-weight: bold;font-size:20px"> {{projectContentList.title}}</p>
                        <!--              <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
                    </div>
                    <div  class="text item">
                        <mt-field label="姓名" placeholder="请填写姓名" v-model="userName" style="border-bottom:1px solid #d9d9d9"></mt-field>
                        <!--                <img src="../assets/logo.jpg" alt="">-->
                        <p style="line-height:40px;font-size:13px">{{projectContentList.remark}}
                        </p>

                                        
                    </div>
                </el-card>

                <el-card class="box-card box_car" v-for="(v,k) in projectContentList.surveyQuestionList" :key="k">
                    <div slot="header" class="clearfix">
                        <span>{{v.question}}</span>
                    </div>
                        <div v-for="(val,key) in v.surveyAnswerList" :key="key" class="text item" style="word-wrap:break-word" >

                            <el-radio  style="width:30px" v-model="radioList[k]" :label="v.id+','+val.id+','+val.point" > <span style="color:transparent">{{val.answer}}</span></el-radio>{{val.answer}}
                        </div>
                </el-card>

                <mt-button type="primary" size="large" @click="addQuestionnaire" >提交</mt-button>
            </div>
            <div v-if="!show">
                <el-card class="box-card3">
                    <div slot="header" class="clearfix">
                        <p style="text-align: center;font-weight: bold;font-size:20px">测试结果</p>

                    </div>
                    <div  class="text item">
                        <p v-for="(v,k1) in str" :key="k1">共选择{{v.num}}个答案{{v.name}}</p>
                        <p>您的性格分析如下：</p>
                        <div v-for="(result,k) in resultList" :key="k">
                            <p style="text-align: center">{{result.remark}}</p>
                            <p style="line-height:40px;font-size:13px">個性:{{result.personality}}</p>
                            <p style="line-height:40px;font-size:13px">表現:{{result.performance}}</p>
                             <p style="line-height:40px;font-size:13px">溝通方法:{{result.communicate}}</p>   
                        </div>
                             
                    </div>
                </el-card>
            </div>
        </div>

    </div>
</template>



<script>
    import "mint-ui/lib/style.css";
    import { Field ,MessageBox,Indicator } from 'mint-ui';
    import {querySurveyById,queryOneByPoint} from '../api/api'
    import $ from 'jquery'
    import Utils from './js/utils.js'

    export default {
        name: "Questionnaire",
        data(){
            return {
                str:[],
                userName:'',
                showMore:false,
                resultList:{},
                radioList:[],
                show:true,
                radio:1,
                textarea:'',
                isRouterAlive:true,
                projectContentList:[],
                businessName:'',
                rangeValue:1,
                visibleItemCountTwo:1,
                FieldNumber:[],
                slots:[
                    {
                        flex: 1,
                        values: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                        className: 'slot1',
                        textAlign: 'left',
                        defaultIndex:9
                    }
                ],
                questionnaireList:[],
                questionnaireIs:true,
                otherOpinions:'',
                waitingTime:0,
                customerName:'',
                insuranceDate:'',
                resultNumList:''
            }
        },
        methods:{
            statisticalFieldNumber(arr) {
                return arr.reduce(function (prev, next) {
                    if(next in prev){
                        prev[next]++
                    }else{
                        prev[next] = 1
                    }
                    return prev
                }, []);
            }
            ,
            GetArrayMost(arr){
                var arrMap = new Map();
                var key = arr[0],
                    value = 1;
                arr.forEach((item, index) => {
                    if (arrMap.get(item) !== undefined) {
                        let num = arrMap.get(item);
                        arrMap.set(item, ++num);
                    } else {
                        arrMap.set(item, 1);
                    }
                    if (arrMap.get(item) > value) {
                        key = item;
                        value = arrMap.get(item);
                    }
                });
                return [key,value];
            },
            getFocusTwo(){
                window.scroll(0, window.document.body.scrollHeight);
            },

            addQuestionnaire(){
                // name（问卷填写人）  result（问卷结果） remark（问卷过程 比如d出现多少次）

                var arr=[]
                var showa=false
                var surveyUserDetailList=[]
                this.radioList.filter(v=>{
                    arr.push(v.split(',')[2])
                    surveyUserDetailList.push({surveyQuestionId:v.split(',')[0],surveyAnswerId:v.split(',')[1]})
                })
                // if(arr.length!=this.projectContentList.surveyQuestionList.length){
                //     MessageBox('提示', '有未填写选项');
                //     return
                // }
                if(this.userName==''){
                    MessageBox('提示', '请填写您的名字');
                    return
                }

                var json={};
                for (var i = 0; i < arr.length; i++) {
                    var key = arr[i];
                    if (json[key]) {
                        json[key]++;
                    }else{
                        json[key]=1;
                    }
                }
                var arr2=[];
                for(var key in json){
                    arr2.push({name:key,count:json[key]})
                }
                arr2.sort(function(n1,n2){return n2.count-n1.count})
                this.FieldNumber=this.statisticalFieldNumber(arr)
                var str=[];
                for (var i = 0; i < arr2.length; i++) {
                    str.push({name:arr2[i].name,num:arr2[i].count})
                }
                this.str=str
                var list='共选择'
                var max=''
                var arr3=[]
                var i=0
                for(let key in this.FieldNumber){
                    list+=this.FieldNumber[key]+'个答案'+key+','
                    if(this.GetArrayMost(arr)[0]==key){
                        max=this.FieldNumber[key]
                    }
                    i++
                }
                this.resultNumList=list
                var arr2=''
                for(let index in this.FieldNumber){
                      if(this.FieldNumber[index]==max){
                          arr2+=index+','
                      }

                }
                Indicator.open('正在查看结果，请稍等');

                let params={surveyDetail:JSON.stringify(surveyUserDetailList),type:1,surveyId:this.$route.query.questionId,point:arr2.substring(0,arr2.length-1),name:this.userName,result:this.GetArrayMost(arr)[0],remark:this.resultNumList}
                queryOneByPoint(params).then(res=>{
                    if(res.errcode==200){
                        this.show=false
                        this.resultList=res.data
                        Indicator.close();
                    }else {
                        this.$message.error(res.errmsg);
                    }
                })

            },


            onValuesChange(picker,values){

                if(picker.valueKey == null){
                    return;
                }
                let id = picker.valueKey.substr(8,picker.valueKey.length);
                if(this.questionnaireList.length<1){
                    let questionnaires = {projectContentId:id,fraction:10,reasonImprovement:''};
                    this.questionnaireList.push(questionnaires);
                }else{
                    this.questionnaireIs =this.questionnaireList.some(item=>{
                        if(item.projectContentId == id){
                            if(values!=undefined){
                                item.fraction = values[0];
                            }else{
                                item.fraction = 10;
                            }
                            return true;
                        }else{
                            return false;
                        }
                    });
                    if(this.questionnaireIs){

                    }else{
                        if(values!=undefined){
                            let questionnaires = {projectContentId:id,fraction:values[0],reasonImprovement:''};
                            this.questionnaireList.push(questionnaires);
                        }else{
                            let questionnaires = {projectContentId:id,fraction:10,reasonImprovement:''};
                            this.questionnaireList.push(questionnaires);
                        }
                    }
                }

            },
            addReason(el){
                let projectId = el.srcElement.parentNode.parentNode.parentNode.id;
                let content = el.srcElement.value;
                if(this.projectContentList.length-projectId <2){
                    window.scroll(0, window.document.body.scrollHeight);
                }
                if(this.questionnaireList.length > 0 && projectId.length != undefined){
                    this.questionnaireIs =this.questionnaireList.some(item=>{
                        if(item.projectContentId == projectId){
                            if(content!=undefined){
                                item.reasonImprovement = content;
                            }else{
                                item.reasonImprovement = '';
                            }
                            return true;
                        }else{
                            return false;
                        }
                    });

                }
            },
            queryProjectContentAll(){

                return querySurveyById(this.$route.query.questionId).then(res=>{
                    if(res.errcode==200){
                        this.projectContentList=res.data;
                        this.showMore=true
                        Indicator.close();

                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryOptionMyPolicy Error");
                });
            }
        },
        mounted() {
            Indicator.open('正在打开，请稍等');

            this.queryProjectContentAll();


        },
    }
</script>

<style scoped>
    .el-radio, .el-radio__input{
        word-wrap:break-word!important;
    }
    body {
        font-family: sans-serif;
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
    /*.box-card2{*/
    /*    width: 100%;*/
    /*    margin:0px auto;*/
    /*    text-align: center;*/
    /*    background: #00ffae;*/
    /*}*/
    .box_car2{
        width: 97%;
        margin:0 auto;
        text-align: center;
    }
    .box_car2{
        width: 97%;
        margin:0 auto;
        text-align: center;
    }
    .box_car{
        width: 97%;
        margin:20px auto;
    }
    .box-card3{
        width:92%;
        margin:20px auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/Questionnaire2.vue